import React, { createContext, useContext, useState, useMemo } from "react";
import it from "./it";

const dictionaries = { it };

const I18nContext = createContext({
  locale: "it",
  t: it,
  setLocale: () => {},
});

export const I18nProvider = ({ children, defaultLocale = "it" }) => {
  const [locale, setLocale] = useState(defaultLocale);
  const value = useMemo(
    () => ({
      locale,
      t: dictionaries[locale] || dictionaries.it,
      setLocale,
    }),
    [locale]
  );
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
